const tabNavigatorAnimationEnabled = false;

export default tabNavigatorAnimationEnabled;
